import { CLOSED_LA_COOKIE } from 'constants/cookies';
import { REDIRECT } from 'constants/reduxActions';

import { call, put, takeEvery } from 'redux-saga/effects';
import { buildAuthenticationRedirectUrl } from 'utils/redirect';
import { setAndStoreCookie } from 'actions/session';
import {
  CLOSE_LA,
  LOGIN_FROM_LA
} from 'store/ducks/loginAssistant/types';
import { delay } from 'store/ducks/rewards/sagas';

export function* watchLoginFromLoginAssistant() {
  yield takeEvery(LOGIN_FROM_LA, workLoginFromLoginAssistant);
}

export function* workLoginFromLoginAssistant({ redirectPath }) {
  yield put({ type: REDIRECT, location: buildAuthenticationRedirectUrl(redirectPath) });
}

export function* watchCloseLoginAssistant() {
  yield takeEvery(CLOSE_LA, workCloseLoginAssistant);
}

export function* workCloseLoginAssistant({ mockDate }) {
  const monthFromNow = mockDate || new Date();
  monthFromNow.setDate(monthFromNow.getDate() + 30);
  yield call(delay, 3000);
  yield put(setAndStoreCookie(CLOSED_LA_COOKIE, 1, monthFromNow));
}

export default [
  watchCloseLoginAssistant,
  watchLoginFromLoginAssistant
];
